//# sourceMappingURL=table.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/table/table.interface.js
// module id = 1189
// module chunks = 4